import { render, staticRenderFns } from "./ImagemTabList.vue?vue&type=template&id=5479dd1c&scoped=true"
import script from "./ImagemTabList.vue?vue&type=script&lang=js"
export * from "./ImagemTabList.vue?vue&type=script&lang=js"
import style0 from "./ImagemTabList.vue?vue&type=style&index=0&id=5479dd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479dd1c",
  null
  
)

export default component.exports